export default __webpack_public_path__ + "static/media/logo.5227a382.svg";